import React from "react";
import { Outlet } from "react-router-dom";

import Box from "@mui/material/Box";
import { MaintenanceBanner } from "components/banner/MaintenanceBanner";
import { Stack } from "@mui/material";

export const ServiceDeskLayout = () => {
  return (
    <Box
      sx={{
        overflow: "hidden",
        height: "calc(100vh - 64px)",
      }}
    >
      <Outlet />
    </Box>
  );
};
